import type { SecondaryFactor } from '../types'

export class UserFacingError extends Error {
  titleKey = 'global.error_title'
  messageKey = 'global.error_message'

  constructor(titleKey: string, messageKey: string) {
    super()
    this.titleKey = titleKey
    this.messageKey = messageKey
  }
}

export class MfaRequiredError extends Error {
  recipient: string
  channel: SecondaryFactor

  constructor(channel: SecondaryFactor, recipient: string) {
    super('missing_authentication_code')
    this.recipient = recipient
    this.channel = channel
  }
}

export class FailedAuthenticationError extends Error {}
export class TooManyAttemptsError extends Error {}
export class InvalidPasswordForPasswordChangeError extends Error {}
export class AccountDeletionCancellationRequiredError extends Error {
  constructor(
    public token: string,
    public request_uuid: string,
  ) {
    super()
  }
}

export enum ErrorCodes {
  EXPIRED_SESSION = 'EXPIRED_SESSION',
  INVALID_GRANT = 'invalid_grant',
  MISSING_AUTHENTICATION_CODE = 'missing_authentication_code',
  INVALID_TWO_STEP_VERIFICATION_CODE = 'invalid_two_step_verification_code',
  ACCOUNT_DELETION_CANCELLATION_REQUIRED = 'account_deletion_cancellation_required',
}
